import { API_ROUTE_ADMIN_TELE_POLICY } from '@/resources/api-routes'
import { del } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export const deleteTelePolicy = async (id: number) => {
  await del<null>(API_ROUTE_ADMIN_TELE_POLICY.replace(':id', String(id)), IS_NEW_BACKEND_API)
  return id
}
